module.exports = __webpack_public_path__ + "img/honor-2.812367e6.png";